import { Card } from 'react-bootstrap';
import { getLevel, getLevelInvariant, getStatus } from '../../services/requestService';
import './RequestItem.css';
import '../../services/DateTimeFormat';
import look from "../../lib/img/look.png";

function RequestItem({ request, onClick, admin }) {
  const styles = `request-item request-item-all-${getLevelInvariant(request.level)?.toLowerCase()}`;
  const stylesw = `color-td request-item-${getLevelInvariant(request.level)?.toLowerCase()}`;
  let processedDate = new Date(request.processedDate);
  if (processedDate.getUTCFullYear() === 0) {
    processedDate = 'Дата не встановлена';
  }
  console.log("admin " +admin);

  return (
    <Card className={styles} tabindex="1">
    {/* <Card className={styles} onClick={() => onClick(request.requestId)}> */}
      <Card.Body>
        <div className="row " id="colCol">
          <div className={stylesw}></div>
          <div className="col rightBorderStyle">{request.requestId} - {new Date(request.date).format("dd.mm.yyyy")}</div>
          <div className="col rightBorderStyle">{getStatus(request.status)}</div>
          <div className="col rightBorderStyle">{getLevel(request.level)}</div>
          <div className="col rightBorderStyle">{request.license?.licenseId}</div>
          <div className="col text-left request-admin-list-product rightBorderStyle">{request.product?.name}</div>
          {/* {admin && <div className="col text-left request-admin-list-company rightBorderStyle">{request.company?.name}<br/> 
            { (request.user?.userName && request.user?.userName != request.user?.email ? request.user?.userName +", ":"") + 
            request.user?.email + 
            (request.user?.phone ? ", " +request.user?.phone:"") }</div>} */}
            {admin && <div className="col text-left request-admin-list-company rightBorderStyle">{request.company?.name}</div>}
          <div className="col text-left request-admin-list-show eyeWrapperStyle" onClick={() => onClick(request.requestId)}>
            <img src={look}/>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default RequestItem;
